import script from "./WebRtcCall.vue?vue&type=script&setup=true&lang=ts"
export * from "./WebRtcCall.vue?vue&type=script&setup=true&lang=ts"

import "./WebRtcCall.vue?vue&type=style&index=0&id=70df42c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70df42c4"]])

export default __exports__